export default __webpack_public_path__ + "static/red-d5597c745356a00ed41784684bc141fe.svg";